import axios from '../../axios'

/*
 * 日程数据接口
 */

// 获取日程数据列表
export const getScheduleList = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/page',
        method: 'get',
        data
    })
}
// 日程数据id查询
export const getScheduleId = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/get',
        method: 'get',
        data
    })
}

// 日程数据新增
export const addSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province',
        method: 'post',
        data
    })
}

// 日程数据更新
export const updateSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province',
        method: 'put',
        data
    })
}

// 日程数据删除
export const deleteSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province',
        method: 'delete',
        data
    })
}

// 省份日程数据导入
export const importSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/import',
        method: 'post',
        data
    })
}
// 高考日程数据导入
export const importExamSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/import',
        method: 'post',
        data
    })
}
// 考后日程数据导入
export const importAfterSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/after/import',
        method: 'post',
        data
    })
}
// 高考日程删除
export const deleteExamSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam',
        method: 'delete',
        data
    })
}
// 考后日程删除
export const delExamAfterSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/after',
        method: 'delete',
        data
    })
}

// 省份日程数据导出
export const exportProvinceSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/export',
        method: 'post',
        data
    })
}

// 批次日程数据导出
export const exportBatchSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/after/export',
        method: 'post',
        data
    })
}

// 高考日程数据导出
export const exportExamSchedule = (data) => {
    return axios({
        url: '/api/base/schedule/exam/export',
        method: 'post',
        data
    })
}

// 省份日程导入更新
export const provinceImportUpdate = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/import/update',
        method: 'post',
        data
    })
}

// 批次日程导入更新
export const batchImportUpdate = (data) => {
    return axios({
        url: '/api/base/schedule/exam/after/import/import',
        method: 'post',
        data
    })
}

// 批次日程导入更新
export const examImportUpdate = (data) => {
    return axios({
        url: '/api/base/schedule/exam/import/update',
        method: 'post',
        data
    })
}

// 省份日程导入删除
export const provinceImportDel = (data) => {
    return axios({
        url: '/api/base/schedule/exam/province/import/delete',
        method: 'post',
        data
    })
}
// 考后日程导入删除
export const batchImportDel = (data) => {
    return axios({
        url: '/api/base/schedule/exam/after/import/delete',
        method: 'post',
        data
    })
}
// 考后日程导入删除
export const examImportDel = (data) => {
    return axios({
        url: '/api/base/schedule/exam/import/delete',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/info/schedule.js